module.exports = __webpack_public_path__ + "static/media/envelope-regular.ea5b517e.svg";